import { inject, Injectable } from '@angular/core';
import { RequestEntitiesService } from './request-entities.service';
import { RequestsApiService } from './requests-api.service';
import { RequestRequiredFieldsSettings } from '@core/types/RequestRequiredFieldsSettings';
import { RequestProduct } from '@core/types';

@Injectable({
  providedIn: 'root',
})
export class RequestProductRequiredFieldsService extends RequestEntitiesService<RequestRequiredFieldsSettings> {
  protected override initialValue = {};
  private readonly requestApiService = inject(RequestsApiService);

  readonly source$ = (requestId: number) =>
    this.requestApiService.getRequiredFieldsSettingsForRequest$(requestId);

  public performRequiredFieldsChecking$(
    requestProduct: RequestProduct,
  ): ReturnType<RequestsApiService['validateRequiredFields$']> {
    return this.requestApiService.validateRequiredFields$(
      this.requestService.$request().id,
      requestProduct.requestProductId.id,
    );
  }
}
